import { useQuery, useQueryClient, useMutation } from 'react-query';
import UserAPI from '../Api/user';

export const useMutateUser = () => {
  const queryClient = useQueryClient();

  queryClient.setMutationDefaults(['update-user'], {
    mutationFn: (variables) => {
      const { data } = variables;
      return UserAPI.update(data);
    },
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  return useMutation(['update-user']);
};

export const useGetBuyers = () =>
  useQuery(['buyers'], () => UserAPI.getBuyers());

export const useGetSponsors = () =>
  useQuery(['sponsors'], () => UserAPI.getSponsors());

export default useMutateUser;
